import React from "react";

import { Pill } from "src/base-components/Pill";

type SdkScriptPillProps = {
  name: string;
  iconSrc?: string;
  // When > 0, an inline "+N more" suffix is rendered inside the same pill to
  // summarise the bundle's remaining member scripts (Figma node 306:2502).
  moreCount?: number;
  dataLoc?: string;
};

export const SdkScriptPill: React.FC<SdkScriptPillProps> = ({
  name,
  iconSrc,
  moreCount,
  dataLoc,
}) => (
  <Pill
    dataLoc={dataLoc ?? "sdk-script-pill"}
    maxWidth
    size="sm"
    variant="gray"
  >
    {iconSrc && (
      <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white">
        <img alt="" className="h-3 w-3 object-contain" src={iconSrc} />
      </span>
    )}
    <Pill.Text>{name}</Pill.Text>
    {moreCount !== undefined && moreCount > 0 && (
      <span className="shrink-0 font-inter-medium-12px">
        {`+${moreCount} more`}
      </span>
    )}
  </Pill>
);
